
import Vue from 'vue';
import ItemSingle from '@/components/parts/catalog/list/item/single';
import ItemDouble from '@/components/parts/catalog/list/item/double';

export default Vue.extend({
  name: 'OrganizationSingleItem',
  props: {
    item: {},
    index: Number,
    constrainNameHeight: Boolean,
  },
  components: { ItemSingle, ItemDouble },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/single_item/OrganizationSingleItem.vue